
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SupportFormLabel',
  props: {
    displayName: {
      type: String,
      default: ''
    },
    helperText: {
      type: String,
      default: null
    }
  }
})
